import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="section bg-[#0d1f33]">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="caption text-[#F7931E] mb-4 block">Testimonials</span>
          <h2 className="heading-2 text-white mb-4">What Our Clients Say</h2>
          <p className="body-large max-w-2xl mx-auto">
            Don't just take our word for it — hear from homeowners who've 
            experienced the Top-Notch difference.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-[#152a42] border border-[#F7931E]/20 p-8 rounded-lg group hover:border-[#F7931E]/50 transition-colors">
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote size={32} className="text-[#1B3A5F]" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} fill="#F7931E" className="text-[#F7931E]" />
                ))}
              </div>

              {/* Quote Text */}
              <p className="text-[#c5d3e3] text-lg leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center justify-between pt-4 border-t border-[#F7931E]/20">
                <div>
                  <p className="text-white font-semibold">{testimonial.name}</p>
                  <p className="text-[#8fa3b8] text-sm">{testimonial.location}</p>
                </div>
                <span className="text-[#F7931E] text-sm font-medium px-3 py-1 bg-[#1B3A5F]/50 rounded-full">
                  {testimonial.project}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
